import {
  createFileRoute,
  Outlet,
  useMatchRoute,
  useNavigate,
} from '@tanstack/react-router';
import useAppLanguage from 'hooks/useAppLanguage';
import usePageConfig from 'hooks/usePageConfig';
import messages from './messages';
import { steps } from './steps';

export const Route = createFileRoute('/_authenticated/verification')({
  component: Verification,
});

function Verification() {
  const language = useAppLanguage();
  const navigate = useNavigate();
  const pageConfig = usePageConfig();

  const matchRoute = useMatchRoute();
  const currentStep = steps.find(step =>
    matchRoute({ to: `/verification/${step.link}` }),
  )!;

  const onChangePageBack = () => {
    let stepNumber = currentStep.stepNumber - 1;
    if (stepNumber === 5) stepNumber -= 1;

    if (stepNumber < 1) {
      navigate({ to: '/settings' });
    } else {
      const redirectStep = steps.find(x => x.stepNumber === stepNumber);
      navigate({ to: `/verification/${redirectStep?.link}` });
    }
  };

  const viewMessages = messages[language].profileVerification;

  return (
    <div className="static lg:relative w-full">
      <button
        type="button"
        onClick={() => onChangePageBack()}
        className="absolute lg:fixed mt-2 ml-6 text-2xl lg:mt-10 lg:ml-6 lg:text-base left-0 top-0 lg:top-auto lg:left-auto z-40 text-header-text focus:outline-none font-semibold">
        <span className="block lg:hidden">←</span>
        <span className="hidden lg:block">← {viewMessages.back}</span>
      </button>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col justify-center lg:px-8 sm:px-6 py-6 lg:py-12">
            <div className="lg:px-8 max-w-2xl mb-7 px-4 sm:px-6">
              <nav className="flex">
                {buildProgressBar(currentStep.stepNumber)}
              </nav>
            </div>
            <Outlet />
            {/* {showError !== true ? null : (
              <div className="mt-6">
                <span className="block text-center text-red-700">
                  {errorMessage}
                </span>
              </div>
            )}
            <Modal
              // largeContent={stepNumber === 8}
              hideModal={closeModal}
              content={renderModalBody()}
              closeModal={closeModal}
              show={showModal || false} 
            />*/}
          </div>
        </div>
        {currentStep.stepNumber > 1 && (
          <div className="text-center">
            <p className="text-white">
              {viewMessages.battlingWithVerification}
            </p>
            <p className="font-extralight">
              {viewMessages.contactUs}

              <a
                href={`mailto:${pageConfig?.app?.supportEmail}`}
                className="text-secondary underline">
                {pageConfig?.app?.supportEmail}
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

function buildProgressBar(stepNumber: number) {
  const results = [];

  for (let i = 0; i <= steps.length; i++)
    if (i < stepNumber)
      results.push(
        <div
          key={`step-${i}`}
          className="border-b-4 border-secondary rounded-b-none flex-1">
          &nbsp;
        </div>,
      );
    else
      results.push(
        <div
          key={`step-${i}`}
          className="border-b-4 border-dark-blue rounded-b-none flex-1">
          &nbsp;
        </div>,
      );

  return results;
}
